// src/utils/checkBuildVersion.js
// Esta función verifica si la versión del build ha cambiado
export async function checkBuildVersion() {
  try {
    const res = await fetch('/');
    const html = await res.text();
    const match = html.match(/<meta name="build-version" content="([^"]+)">/);
    const current = match ? match[1] : null;
    const stored = localStorage.getItem('build_version');

    if (current && stored && current !== stored) {
      console.log('🔁 Nueva versión detectada. Recargando...');
      localStorage.setItem('build_version', current);
      window.location.reload(true);
    } else if (current && !stored) {
      localStorage.setItem('build_version', current);
    }
  } catch (err) {
    console.warn('No se pudo verificar la versión del build:', err);
  }
}
